// @flow
import { get } from 'lodash';
import { reject } from 'redux-optimist-promise';

import {
  CREATE_ADDITIONAL_TRANSPORTS_FILTERS,
  FETCH_ADDITIONAL_TRANSPORTS,
} from 'Store/booking/additional-transports/additionalTransports.action';

type State = boolean;

const initialState: State = false;

function isLoadingReducer(state: State = initialState, action: ?Action<*>): State {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_TRANSPORTS:
      return true;

    case CREATE_ADDITIONAL_TRANSPORTS_FILTERS:
    case reject(FETCH_ADDITIONAL_TRANSPORTS):
      return false;

    default:
      return state;
  }
}

export default isLoadingReducer;
